import { render, staticRenderFns } from "./KadoMenu.vue?vue&type=template&id=71eaefd2&scoped=true"
import script from "./KadoMenu.vue?vue&type=script&lang=js"
export * from "./KadoMenu.vue?vue&type=script&lang=js"
import style0 from "./KadoMenu.vue?vue&type=style&index=0&id=71eaefd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71eaefd2",
  null
  
)

export default component.exports